export const salesAdminRoute = {
  base: '/sales-salesAdmin',
  jobs: '/jobs',
  crm: '/crm',
  leads: '/leads',
  clients: '/clients',
  communication: '/communication',
  quotes: '/quotes',
  inventory: '/inventory',
  product: '/product',
  package: '/package',
  settings: '/settings',
  users: '/users',
  schedule: '/schedule',
  vehicles: '/vehicles',
  trucks: '/trucks',
  equipments: '/equipments',
  trailers: '/trailers',
  vendors: '/vendors',
  purchaseOrder: '/purchase-order',
  order: '/order',
  roleManagement: '/role-management',
  coupon: '/coupon',
  eventType: '/event-type',
  category: '/category',
  quarantines: '/quarantine',
  invoice: '/invoice',
  checklist: '/checklist',
  task: '/task',
  global: '/global',
  venue: '/venue',

  // Reports
  reports: '/reports',
  overbookingItem: '/overbooking-item',
  subrentalsReport: '/subrentals',
  quarantineReport: '/quarantine',
  foremanTaskReport: '/foreman-task-completion',
  clientIncomeReport: '/client-income',
  revenueReport: '/revenue',
  geographicRevenueReport: '/geographic-revenue',
  quoteRevenueReport: '/quote-revenue',
  orderRevenueReport: '/order-revenue',
  cancellationReport: '/cancellation',
  deliveryReport: '/delivery-pickup',
  taskCompletionReport: '/task-completion',
  discountUsageReport: '/discount-usage',
  featureUtilizationReport: '/feature-utilization',
  jobCostingReport: '/job-costing',
  inventoryUsageReport: '/inventory-usage',
  marketingRevenueReport: '/marketing-revenue',
  financialOrderReport: '/financial-order',
  transactionSummaryReport: '/transaction-summary',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonClone: '/clone',
  commonDetail: '/:id',
};

export const salesAdminRouteVehicles = {
  vehicles: `${salesAdminRoute.base}${salesAdminRoute.vehicles}`,
};

export const salesAdminRouteTrucks = {
  trucks: `${salesAdminRoute.base}${salesAdminRoute.vehicles}${salesAdminRoute.trucks}`,
};

export const salesAdminRouteEquipments = {
  equipments: `${salesAdminRoute.base}${salesAdminRoute.vehicles}${salesAdminRoute.equipments}`,
};

export const salesAdminRouteTrailers = {
  trailers: `${salesAdminRoute.base}${salesAdminRoute.vehicles}${salesAdminRoute.trailers}`,
};

export const salesAdminRouteVendors = {
  vendors: `${salesAdminRoute.base}${salesAdminRoute.vendors}`,
  detailVendor: `${salesAdminRoute.base}${salesAdminRoute.vendors}${salesAdminRoute.commonDetail}`,
};

export const salesAdminRoutePurchaseOrder = {
  purchaseOrder: `${salesAdminRoute.base}${salesAdminRoute.purchaseOrder}`,
  detailPurchaseOrder: (purchaseOrderId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.purchaseOrder}/${purchaseOrderId}`,
};

export const salesAdminRouteOrder = {
  order: `${salesAdminRoute.base}${salesAdminRoute.order}`,
  detailOrder: (orderId: string) => `${salesAdminRoute.base}${salesAdminRoute.order}/${orderId}`,
  updateOrder: (orderId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.order}/${orderId}${salesAdminRoute.commonEdit}`,
};

export const salesAdminRouteCrm = {
  crm: `${salesAdminRoute.base}${salesAdminRoute.crm}`,
  leads: `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.leads}`,
  createLead: `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.leads}${salesAdminRoute.commonCreate}`,
  detailLead: (leadId: string) => `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.leads}/${leadId}`,
  updateLead: (leadId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.leads}/${leadId}${salesAdminRoute.commonEdit}`,
  clients: `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.clients}`,
  createClient: `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.clients}${salesAdminRoute.commonCreate}`,
  detailClient: (clientId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.clients}/${clientId}`,
  updateClient: (clientId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.clients}/${clientId}${salesAdminRoute.commonEdit}`,
};

export const salesAdminRouteQuote = {
  quotes: `${salesAdminRoute.base}${salesAdminRoute.quotes}`,
  createQuotes: `${salesAdminRoute.base}${salesAdminRoute.quotes}${salesAdminRoute.commonCreate}`,
  detailQuote: (quoteId: string) => `${salesAdminRoute.base}${salesAdminRoute.quotes}/${quoteId}`,
  updateQuote: (quoteId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.quotes}/${quoteId}${salesAdminRoute.commonEdit}`,
};

export const salesAdminRouteInventory = {
  inventories: `${salesAdminRoute.base}${salesAdminRoute.inventory}`,
  inventory: `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.product}`,
  createInventory: `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.product}${salesAdminRoute.commonCreate}`,
  detailInventory: (inventoryId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.product}/${inventoryId}`,
  updateInventory: (inventoryId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.product}/${inventoryId}${salesAdminRoute.commonEdit}`,
};

export const salesAdminRoutePackage = {
  package: `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.package}`,
  createPackage: `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.package}${salesAdminRoute.commonCreate}`,
  updatePackage: (packageId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.package}/${packageId}${salesAdminRoute.commonEdit}`,
  clonePackage: (packageId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.package}/${packageId}${salesAdminRoute.commonClone}`,
};

export const salesAdminRouteUser = {
  users: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.users}`,
  createUser: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.users}${salesAdminRoute.commonCreate}`,
  detailUser: (userId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.users}/${userId}`,
  updateUser: (userId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.users}/${userId}${salesAdminRoute.commonEdit}`,
};

export const salesAdminRouteVenue = {
  venue: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.venue}`,
  createVenue: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.venue}${salesAdminRoute.commonCreate}`,
  detailVenue: (venueId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.venue}/${venueId}`,
  updateVenue: (venueId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.venue}/${venueId}${salesAdminRoute.commonEdit}`,
};

export const salesAdminRouteInvoice = {
  invoices: `${salesAdminRoute.base}${salesAdminRoute.invoice}`,
  createInvoice: `${salesAdminRoute.base}${salesAdminRoute.invoice}${salesAdminRoute.commonCreate}`,
  updateInvoice: (invoiceId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.invoice}/${invoiceId}${salesAdminRoute.commonEdit}`,
};

export const salesAdminRouteRoleManagement = {
  roleManagement: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.roleManagement}`,
  createRole: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.roleManagement}${salesAdminRoute.commonCreate}`,
  updateRole: (roleId: string) =>
    `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.roleManagement}/${roleId}${salesAdminRoute.commonEdit}`,
};

export const salesAdminRouteRoleCoupon = {
  coupon: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.coupon}`,
};

export const salesAdminRouteRoleEventType = {
  eventType: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.eventType}`,
};

export const salesAdminRouteRoleCategory = {
  category: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.category}`,
};

export const salesAdminRouteRoleChecklist = {
  checklist: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.checklist}`,
};

export const salesAdminRouteJob = {
  jobs: `${salesAdminRoute.base}${salesAdminRoute.jobs}`,
  detailJob: (jobId: string) => `${salesAdminRoute.base}${salesAdminRoute.jobs}/${jobId}`,
};

export const salesAdminRouteQuarantine = {
  quarantine: `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.quarantines}`,
};

export const salesAdminRouteTask = {
  task: `${salesAdminRoute.base}${salesAdminRoute.task}`,
};

export const salesAdminRouteGlobal = {
  global: `${salesAdminRoute.base}${salesAdminRoute.global}`,
};

export const salesAdminRouteReport = {
  reports: `${salesAdminRoute.base}${salesAdminRoute.reports}`,
  overbookingItem: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.overbookingItem}`,
  subrentalsReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.subrentalsReport}`,
  clientIncomeReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.clientIncomeReport}`,
  revenueReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.revenueReport}`,
  geographicRevenueReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.geographicRevenueReport}`,
  quoteRevenueReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.quoteRevenueReport}`,
  orderRevenueReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.orderRevenueReport}`,
  cancellationReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.cancellationReport}`,
  deliveryReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.deliveryReport}`,
  taskCompletionReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.taskCompletionReport}`,
  discountUsageReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.discountUsageReport}`,
  featureUtilizationReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.featureUtilizationReport}`,
  jobCostingReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.jobCostingReport}`,
  inventoryUsageReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.inventoryUsageReport}`,
  quarantineReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.quarantineReport}`,
  foremanTaskReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.foremanTaskReport}`,
  marketingRevenueReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.marketingRevenueReport}`,
  financialOrderReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.financialOrderReport}`,
  transactionSummaryReport: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.transactionSummaryReport}`,
};

export const salesAdminRouteAbsolute = {
  // Dashboard
  dashboard: salesAdminRoute.base,

  // Communication
  communication: `${salesAdminRoute.base}${salesAdminRoute.communication}`,

  // Settings
  settings: `${salesAdminRoute.base}${salesAdminRoute.settings}`,

  // Schedule
  schedule: `${salesAdminRoute.base}${salesAdminRoute.schedule}`,

  ...salesAdminRouteVehicles,
  ...salesAdminRouteTrucks,
  ...salesAdminRouteEquipments,
  ...salesAdminRouteTrailers,
  ...salesAdminRouteVendors,
  ...salesAdminRoutePurchaseOrder,
  ...salesAdminRouteOrder,
  ...salesAdminRouteCrm,
  ...salesAdminRouteQuote,
  ...salesAdminRouteInventory,
  ...salesAdminRoutePackage,
  ...salesAdminRouteUser,
  ...salesAdminRouteVenue,
  ...salesAdminRouteRoleManagement,
  ...salesAdminRouteRoleCoupon,
  ...salesAdminRouteRoleEventType,
  ...salesAdminRouteRoleCategory,
  ...salesAdminRouteRoleChecklist,
  ...salesAdminRouteJob,
  ...salesAdminRouteQuarantine,
  ...salesAdminRouteInvoice,
  ...salesAdminRouteReport,
  ...salesAdminRouteTask,
  ...salesAdminRouteGlobal,
};
